@if(unitType) {
  <div class="card">
    <div class="bg">
      <img src="assets/images/apartment-meter-card-bg.png">
    </div>

    <div class="card-header" [ngStyle]="{background: 'linear-gradient(to bottom, rgba('+ color+', 0.1), transparent)' }">
          <div class="card-icon">
            <unit-type-icon [unitType]="unitType"/>
          </div>

      <div class="card-title">
        <span unitType [type]="unitType" [onlyText]="true"></span>
      </div>
    </div>

    <div class="card-body">
      <h3>{{ unitType?.type  }}</h3>
    </div>

    <div class="card-footer">
      <div class="info-line">
        <div class="icon-label">
          <i class="las la-euro-sign me-2"></i>
          <strong>{{ 'TARIFFS.PRICE' | translate }}:</strong>
        </div>
        <span class="ml-auto">{{ data.price | moneyFormat }}</span>
      </div>

      <div class="info-line">
        <div class="icon-label">
          <i class="las la-percentage me-2"></i>
          <strong>{{ 'UTILITYRATES.TAXRATE' | translate }}:</strong>
        </div>
        <span class="ml-auto">{{ data.taxRate }}%</span>
      </div>
    </div>
  </div>
} @else {
  <div class="card">
    <div class="card-body">
      <h3>Unit Type Not Found</h3>
    </div>
  </div>
}
